var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { Box, Button, Card, CardContent, CircularProgress, Link as MuiLink, Typography, } from "@mui/material";
import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useJoinTeamByLink, usePreviewInviteLink, } from "../api/InvitationApiProvider";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
export var JoinTeamByLink = function () {
    var _a;
    var token = useParams().token;
    var navigate = useNavigate();
    var _b = __read(React.useState(""), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = usePreviewInviteLink({ token: token }), preview = _c.data, isPreviewLoading = _c.isLoading, isPreviewError = _c.isError;
    var joinMutation = useJoinTeamByLink({
        onMutate: function () { },
        onSuccess: function (response) {
            var _a;
            var teamId = (_a = response.data) === null || _a === void 0 ? void 0 : _a.team;
            // Route new players through the profile bridge; it self-skips for
            // already-onboarded users.
            navigate(teamId ? "/welcome/profile/".concat(teamId) : "/teams");
        },
        onError: function (error) {
            var _a, _b;
            var messages = Object.values((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {})
                .flat()
                .join(" ");
            if (messages.includes("already a member") && (preview === null || preview === void 0 ? void 0 : preview.team)) {
                navigate("/teams/".concat(preview.team));
            }
            else {
                setErrorMessage(messages || "Failed to join team. The link may be invalid or expired.");
            }
        },
    });
    if (!token) {
        return (_jsx(Box, { sx: { textAlign: "center", mt: 8 }, children: _jsx(Typography, { variant: "h5", color: "error", children: "Invalid invite link" }) }));
    }
    if (isPreviewLoading) {
        return _jsx(Loading, {});
    }
    var teamName = preview === null || preview === void 0 ? void 0 : preview.teamName;
    var teamId = preview === null || preview === void 0 ? void 0 : preview.team;
    var isUsable = (_a = preview === null || preview === void 0 ? void 0 : preview.isUsable) !== null && _a !== void 0 ? _a : false;
    return (_jsxs(React.Fragment, { children: [_jsx(Box, { sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "60vh",
                }, children: _jsx(Card, { variant: "outlined", sx: { maxWidth: 450, width: "100%", p: 2 }, children: _jsx(CardContent, { sx: { textAlign: "center" }, children: joinMutation.isLoading ? (_jsxs(_Fragment, { children: [_jsx(CircularProgress, { sx: { mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "Joining team..." })] })) : joinMutation.isError ? (_jsxs(_Fragment, { children: [_jsx(GroupAddIcon, { color: "error", sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "Unable to join" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: errorMessage || "The link may be invalid or expired." })] })) : joinMutation.isSuccess ? (_jsxs(_Fragment, { children: [_jsx(CircularProgress, { sx: { mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "Redirecting..." })] })) : isPreviewError || !isUsable ? (_jsxs(_Fragment, { children: [_jsx(GroupAddIcon, { color: "error", sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "Invalid link" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: "This invite link is invalid, expired, or has been revoked." })] })) : (_jsxs(_Fragment, { children: [_jsx(GroupAddIcon, { color: "primary", sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "You've been invited to join" }), _jsx(Typography, { variant: "h4", sx: { fontWeight: 700, mb: 1 }, children: _jsx(MuiLink, { component: Link, to: "/teams/".concat(teamId), underline: "hover", children: teamName }) }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: "Click below to accept the invitation and join the team." }), _jsxs(Button, { variant: "contained", size: "large", onClick: function () { return joinMutation.mutate(token); }, children: ["Join ", teamName] })] })) }) }) }), _jsx(ErrorSnackbar, { open: !!errorMessage, onClose: function () { return setErrorMessage(""); }, message: errorMessage })] }));
};
